<template>
  <Head v-if="shouldRenderHrefLangs">
    <template v-for="link in validHrefLangs" :key="link.hid">
      <Link
        :id="link.hid"
        :rel="link.rel"
        :href="link.href"
        :hreflang="link.hreflang"
      />
    </template>
  </Head>
  <div class="layout-default">
    <Navbar />
    <div class="page">
      <slot />
    </div>
    <PageSEOContent />
    <Footer class="footer" />
  </div>
</template>
<script setup lang="ts">
const route = useRoute();
const { validHrefLangs } = useHrefLangs();

/** Some pages don't have a hreflang alternative, these can specify this meta attribute to overwrite the current (global) hreflang values.  */
const shouldRenderHrefLangs = computed(
  () => route.meta?.disableHrefLangs !== true || false,
);

</script>
<style lang="scss" scoped>
.layout-default {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  touch-action: pan-y;

  .page {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .footer {
    margin-top: auto;
  }
}
</style>
